import { render, staticRenderFns } from "./resume-certifications.vue?vue&type=template&id=2acaf3c5&scoped=true"
import script from "./resume-certifications.vue?vue&type=script&lang=js"
export * from "./resume-certifications.vue?vue&type=script&lang=js"
import style0 from "./resume-certifications.vue?vue&type=style&index=0&id=2acaf3c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acaf3c5",
  null
  
)

export default component.exports